import { useBooleanFlagValue } from '@openfeature/react-sdk';

export const WORK_SOURCE_CITATION_CHIPS_FLAG_KEY =
  'release-scribe-work-source-citation-chips';

/** Gates the compact, actionable Work source-citation chips. Defaults off. */
export const useIsWorkSourceCitationChipsEnabled = () =>
  useBooleanFlagValue(WORK_SOURCE_CITATION_CHIPS_FLAG_KEY, false);
